export default function Contact() {
  return (
    <section id="contato" className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-5">
        <div className="grid md:grid-cols-2 gap-16 items-center">

          {/* Left */}
          <div>
            <span className="reveal inline-block text-xs tracking-[0.2em] uppercase text-brand-gold font-body font-semibold mb-4">
              Fale conosco
            </span>
            <h2 className="reveal font-display font-black text-4xl md:text-5xl text-brand-dark leading-tight mb-5" data-delay="100">
              Pronto para<br />começar?
            </h2>
            <p className="reveal font-body text-gray-500 text-sm leading-relaxed mb-8 max-w-xs" data-delay="200">
              Entre em contato pelo WhatsApp e nossa equipe responderá o mais rápido possível.
            </p>

            <div className="reveal space-y-4" data-delay="300">
              <a
                href="https://wa.me/11946384844"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 group"
              >
                <div className="w-10 h-10 rounded-full bg-brand-green/10 flex items-center justify-center group-hover:bg-brand-green transition-colors">
                  <svg className="w-5 h-5 text-brand-green group-hover:text-white transition-colors" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                </div>
                <div>
                  <div className="font-body text-xs text-gray-400">WhatsApp</div>
                  <div className="font-body font-medium text-brand-dark text-sm">11 94638-4844</div>
                </div>
              </a>

              <a
                href="mailto:campostransportes.adm@gmail.com"
                className="flex items-center gap-4 group"
              >
                <div className="w-10 h-10 rounded-full bg-brand-green/10 flex items-center justify-center group-hover:bg-brand-green transition-colors">
                  <svg className="w-5 h-5 text-brand-green group-hover:text-white transition-colors" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                  </svg>
                </div>
                <div>
                  <div className="font-body text-xs text-gray-400">E-mail</div>
                  <div className="font-body font-medium text-brand-dark text-sm">campostransportes.adm@gmail.com</div>
                </div>
              </a>
            </div>
          </div>

          {/* Right — decorative quote card */}
          <div className="reveal" data-delay="200">
            <div className="relative bg-brand-light rounded-sm p-8 border border-gray-100">
              <div className="absolute -top-3 -left-3 w-8 h-8 bg-brand-gold rounded-sm flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11.192 15.757c0-.88-.23-1.618-.69-2.217-.326-.412-.768-.683-1.327-.812-.55-.128-1.07-.137-1.54-.028-.16-.95.1-1.95.78-3a8.6 8.6 0 0 1 2.077-2.233L8.9 6.19a13.2 13.2 0 0 0-2.84 2.696C5.11 10.27 4.5 11.94 4.5 13.57c0 1.52.44 2.7 1.31 3.54.876.84 1.99 1.26 3.344 1.26 1.26 0 2.273-.4 3.04-1.2.765-.8 1-.72 1-1.41zm8.5 0c0-.88-.23-1.618-.69-2.217-.326-.42-.77-.692-1.327-.817-.55-.124-1.07-.13-1.54-.022-.16-.95.1-1.95.78-3a8.6 8.6 0 0 1 2.077-2.233L17.4 6.19a13.2 13.2 0 0 0-2.84 2.696c-.95 1.38-1.56 3.05-1.56 4.684 0 1.52.44 2.7 1.31 3.54.876.84 1.99 1.26 3.344 1.26 1.26 0 2.273-.4 3.04-1.2.765-.8 1.197-1.72 1.197-2.41z"/>
                </svg>
              </div>
              <p className="font-body text-gray-600 text-sm leading-relaxed italic mb-6">
                "Nossa equipe está pronta para garantir que sua carga chegue com segurança e pontualidade. Entre em contato e receba sua cotação personalizada."
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-brand-green flex items-center justify-center">
                  <span className="text-white font-display font-bold text-sm">CT</span>
                </div>
                <div>
                  <div className="font-body font-semibold text-sm text-brand-dark">Equipe Campos</div>
                  <div className="font-body text-xs text-gray-400">Transportes</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
